<div
  class="app-toast-stack toast toast-bottom toast-center pointer-events-none z-[1100] w-full max-w-2xl gap-2 whitespace-normal p-4 sm:pb-16"
>
  @for (toast of notifications.toasts(); track toast.id) {
    <div
      [class]="visualsFor(toast).container"
      [class.toast-leaving]="toast.leaving"
      class="grid grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-3 w-full whitespace-normal rounded-lg border bg-base-100 shadow-md p-3 pointer-events-auto"
      role="alert"
    >
      <div
        [class]="visualsFor(toast).iconWrap"
        class="rounded-lg p-1.5 flex items-center justify-center"
      >
        <app-icon
          [class]="visualsFor(toast).iconColor"
          [name]="visualsFor(toast).iconName"
          class="h-4 w-4"
        />
      </div>

      <p
        class="whitespace-normal break-words text-sm leading-snug text-base-content [overflow-wrap:anywhere]"
      >
        {{ toast.messageKey | translate: toast.options.params ?? {} }}
      </p>

      <button
        [attr.aria-label]="'SHARED.TOAST.DISMISS' | translate"
        (click)="dismiss(toast.id)"
        class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-base-content/70 hover:text-base-content hover:bg-base-200 transition-colors"
        type="button"
      >
        <app-icon class="h-4 w-4" name="x-mark" />
      </button>
    </div>
  }
</div>
